var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 866.414,
    viewBox: "0 0 1920 866.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89780",
    "data-name": "Path 89780",
    d: "M578.7,281.4c204.306-9.273,569.17-146.039,815.185-176.039,332.684-40.57,524.62,7.96,524.62,24.636V956H.137s-3.671-726.384,0-738.933S99.109,303.17,578.7,281.4Z",
    transform: "translate(1.494 -89.586)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDesktop);
export default __webpack_public_path__ + "static/media/background_desktop.cd0646da8a5a7c0629e4bd6049813c2b.svg";
export { ForwardRef as ReactComponent };